import Parser from '@/services/parsers/index';

// Returns filtered and available floorplan list
const filteredFloorplanList = (state) => {
  let floorplanList = state.list;
  // Filter type (beds + den)

  // Check and filter favourited
  if (state.showFavourites) {
    floorplanList = floorplanList
      .filter(floorplan => floorplan.favourited);
  } else {
    const filteredTypes =
      state.filters.typeList
        .filter(type => type.active).map(type => type.slug);
    if (filteredTypes.length > 0) {
      floorplanList = floorplanList
        .filter((floorplan) => {
          const beds = Parser.adhocParser.bedsToTypeSlug(floorplan.beds);
          const den = Parser.adhocParser.densToTypeSlug(floorplan.dens);
          const typeSlug = beds + den;
          return filteredTypes.includes(typeSlug);
        });
    }

    // Filter exposure
    const filteredExposure =
      state.filters.exposureList
        .filter(exposure => exposure.active).map(exposure => exposure.slug);
    if (filteredExposure.length > 0) {
      floorplanList = floorplanList
        .filter(floorplan =>
          floorplan.suites.some(suite =>
            suite.exposure.split('').some(exposure => filteredExposure.includes(exposure))
          )
        );
    }

    // Filter baths
    const filteredBaths =
      state.filters.bathList
        .filter(bath => bath.active).map(bath => bath.slug);
    if (filteredBaths.length > 0) {
      floorplanList = floorplanList
        .filter(floorplan => filteredBaths.includes(floorplan.baths.toString()));
    }

    // Filter size
    floorplanList = floorplanList
      .filter(floorplan =>
        floorplan.interior >= state.filters.sqftRange.min &&
        floorplan.interior <= state.filters.sqftRange.max
      );

    // Filter floors
    floorplanList = floorplanList
      .filter(floorplan =>
        floorplan.suites.some(suite =>
          suite.floor >= state.filters.floorRange.min &&
          suite.floor <= state.filters.floorRange.max
        )
      );

    // Collections
    const filteredCollections =
      state.filters.collectionList
        .filter(collection => collection.active).map(collection => collection.slug);
    if (filteredCollections.length > 0) {
      let planList = [];
      console.log(state);
      filteredCollections.forEach((collection) => {
        console.log(state.collectionMapping[collection]);
        if (planList.length === 0) {
          planList = state.collectionMapping[collection];
        } else {
          planList = planList.concat(state.collectionMapping[collection]);
        }
        console.log(planList);
      });
      console.log('collections filter list', planList);
      floorplanList = floorplanList.filter(plan => planList.includes(plan.name));
    }
  }

  // Filter search
  if (state.filters.searchString.length > 0) {
    floorplanList = floorplanList
      .filter(floorplan =>
        (floorplan.name.toLowerCase()
          .includes(state.filters.searchString.toLowerCase())
        )
      );
  }

  // Filter status available
  floorplanList = floorplanList
    .filter((floorplan) => {
      const unitCount = floorplan.suites.filter(suite => suite.status === 'available').length;
      return unitCount > 0;
    });

  return floorplanList;
};

const isFiltered = (state) => {
  let filteredLength = state.filters.typeList
    .filter(type => type.active).map(type => type.slug).length;

  filteredLength += state.filters.exposureList
    .filter(exposure => exposure.active).map(exposure => exposure.slug).length;

  filteredLength += state.filters.bathList
    .filter(bath => bath.active).map(bath => bath.slug).length;

  return !(
    filteredLength === 0 &&
    state.filters.sqftRange.min === state.filters.sqftRange.default.min &&
    state.filters.sqftRange.max === state.filters.sqftRange.default.max &&
    state.filters.floorRange.min === state.filters.floorRange.default.min &&
    state.filters.floorRange.max === state.filters.floorRange.default.max &&
    state.filters.searchString.length === 0
  );
};

const filteredUnitList = (state, getters) => {
  const unitList = [];
  getters.filteredFloorplanList.forEach((floorplan) => {
    floorplan.suites.forEach((suite) => {
      if (suite.status === 'available' &&
        parseInt(suite.floor, 10) >= state.filters.floorRange.min &&
        parseInt(suite.floor, 10) <= state.filters.floorRange.max
      ) {
        unitList.push(suite.name);
      }
    });
  });
  return unitList;
};

const floorplanAvailableUnitList = (state, getters) => (floorplanId) => {
  const selectedFloorplan =
    getters.filteredFloorplanList
    .find(floorplan => floorplan.id === floorplanId);
  const availableUnitList = [];
  if (selectedFloorplan) {
    selectedFloorplan.suites.forEach((suite) => {
      if (suite.status === 'available') {
        availableUnitList.push(suite.name);
      }
    });
  }
  return availableUnitList;
};

const favouritedCount = state => state.list.filter(floorplan => floorplan.favourited).length;

const totalFloorplanCount = state => state.list.length;

const getFloorplanById = (state, getters) => (floorplanId) => {
  const floorplanList = getters.filteredFloorplanList;
  const floorplanIndex = floorplanList.findIndex(floorplan => floorplan.id === floorplanId);
  const currentFloorplan = floorplanList[floorplanIndex];
  return {
    current: currentFloorplan,
    prev: floorplanList[floorplanIndex - 1],
    next: floorplanList[floorplanIndex + 1]
  };
};

const getFloorplanByUnitName = (state, getters) => (unitName) => {
  const plan = getters.filteredFloorplanList.find(floorplan =>
    floorplan.suites.find(suite => suite.name === unitName)
  );
  console.log(plan);
  return plan;
};

const getExposureByUnitName = state => (unitName) => {
  const foundFloorplan = state.list.find(floorplan =>
    floorplan.suites.find(suite => suite.name === unitName)
  );
  const foundSuite = foundFloorplan.suites.find(suite => suite.name === unitName);
  return foundSuite.exposure;
};

export default {
  filteredFloorplanList,
  isFiltered,
  filteredUnitList,
  floorplanAvailableUnitList,
  favouritedCount,
  totalFloorplanCount,
  getFloorplanById,
  getFloorplanByUnitName,
  getExposureByUnitName
};



// WEBPACK FOOTER //
// ./src/store/modules/floorplans/getters.js